import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogujratcabservice() {



const cardData = {
  keyword: " Pune to Gujarat Cab Service ",

"headingDescription": "SRS Cab Service offers Pune to Gujarat Cab Service, providing a comfortable, safe, and reliable long-distance travel option for families, business travelers, and tourists. Our well-maintained vehicles, experienced drivers, and timely pickups ensure a smooth and hassle-free journey from Pune to various destinations across Gujarat. Ideal for business trips, pilgrimage tours, and family vacations, SRS Cab Service delivers flexible booking options, transparent pricing, and 24/7 customer support for a convenient and enjoyable travel experience.",
"topPlaces": [
  {
    "title": "Ahmedabad",
    "description": "Ahmedabad is the largest city in Gujarat known for its heritage and culture. Travelers using SRS Cab Service from Pune often visit for business, shopping, and exploring historical sites."
  },
  {
    "title": "Statue of Unity",
    "description": "Statue of Unity is the world’s tallest statue dedicated to Sardar Vallabhbhai Patel. Visitors using SRS Cab Service often include this iconic attraction in their Gujarat trip."
  },
  {
    "title": "Somnath Temple",
    "description": "Somnath Temple is one of the twelve Jyotirlingas of Lord Shiva. Travelers using SRS Cab Service often visit this sacred site for spiritual and pilgrimage purposes."
  },
  {
    "title": "Dwarka",
    "description": "Dwarka is a holy city associated with Lord Krishna. Visitors using SRS Cab Service often travel here for temple visits and spiritual experiences."
  },
  {
    "title": "Gir National Park",
    "description": "Gir National Park is famous for Asiatic lions and wildlife safaris. Travelers using SRS Cab Service often include this destination for nature and wildlife exploration."
  },
  {
    "title": "Rann of Kutch",
    "description": "Rann of Kutch is a vast white salt desert known for its unique landscape. Visitors using SRS Cab Service often visit during the Rann Utsav for cultural experiences."
  },
  {
    "title": "Vadodara",
    "description": "Vadodara is known for its palaces and cultural heritage. Travelers using SRS Cab Service often explore its architecture and museums."
  },
  {
    "title": "Saputara",
    "description": "Saputara is a hill station in Gujarat offering scenic beauty and cool climate. Visitors using SRS Cab Service often visit for relaxation and nature views."
  },
  {
    "title": "Junagadh",
    "description": "Junagadh is a historic city with forts and temples. Travelers using SRS Cab Service often explore its heritage and nearby Girnar hills."
  },
  {
    "title": "Palitana Temples",
    "description": "Palitana Temples are a sacred Jain pilgrimage site with numerous temples on Shatrunjaya Hill. Visitors using SRS Cab Service often visit for spiritual journeys."
  }
],



services: [
{
name: "Pune to Surat Cab Booking",
description: "Pune to Surat cab booking offers easy reservation for long-distance travel. Customers can book cabs online or offline. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily from Pune to Surat with cab services."
},
{
name: "Pune to Surat Cab Price",
description: "Pune to Surat cab price provides estimated pricing for travel planning. Customers can compare costs before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab price services."
},
{
name: "Pune to Surat Cab",
description: "Pune to Surat cab offers reliable transportation for business and leisure trips. Customers can book cabs for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Surat Taxi Cab Hire",
description: "Pune to Surat taxi cab hire provides flexible vehicle options for long trips. Customers can hire taxis for business and family travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi hire services."
},
{
name: "Pune to Gujarat Cab Booking",
description: "Pune to Gujarat cab booking offers quick reservation for multiple destinations. Customers can book cabs for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily to Gujarat."
},
{
name: "Pune to Ahmedabad Cab",
description: "Pune to Ahmedabad cab provides reliable intercity travel for business and tourism. Customers can book cabs for long-distance journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Ahmedabad."
},
{
name: "Pune to Vadodara Cab",
description: "Pune to Vadodara cab offers convenient travel for business and family trips. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Vadodara."
},
{
name: "Pune to Rajkot Cab Service",
description: "Pune to Rajkot cab service provides dependable transportation for long-distance trips. Customers can book cabs for business and leisure travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Gujarat Round Trip Cab Service",
description: "Pune to Gujarat round trip cab service offers convenient two-way travel options. Customers can book cabs for multi-day journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with round trip cab services."
},
{
name: "Pune to Pavagadh Taxi Service",
description: "Pune to Pavagadh taxi service offers convenient travel for temple visits. Customers can book taxis for pilgrimage journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Gandhinagar Gujarat Taxi Service",
description: "Pune to Gandhinagar Gujarat taxi service provides reliable travel for business and tourism. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Somnath Trip with Murali Cabs",
description: "Pune to Somnath trip with Murali cabs offers complete travel solutions for pilgrimage tours. Customers can book cabs for temple visits. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Somnath."
},
{
name: "Pune to Bhavnagar Cab Service",
description: "Pune to Bhavnagar cab service provides reliable transportation for long-distance travel. Customers can book cabs for business and leisure trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune Vadodara Cab Booking",
description: "Pune Vadodara cab booking offers quick reservation options for travelers. Customers can book cabs online or offline. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Pune to Gujarat Tempo Traveller on Rent",
description: "Pune to Gujarat tempo traveller on rent offers group travel solutions for long trips. Customers can book spacious vehicles for family and corporate travel. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with tempo traveller services."
},
{
name: "Pune to Rajkot Cab",
description: "Pune to Rajkot cab offers reliable transportation for long-distance travel. Customers can book cabs for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily to Rajkot with cab services."
},
{
name: "Pune to Statue of Unity Cab",
description: "Pune to Statue of Unity cab offers convenient travel for sightseeing trips. Customers can book cabs for tourism journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Gujarat Cab Service",
description: "Pune to Gujarat cab service provides dependable transportation for multiple destinations. Customers can book cabs for flexible travel plans. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Gujarat Cab",
description: "Pune to Gujarat cab offers reliable long-distance travel for business and leisure. Customers can book cabs for comfortable journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Gujarat Taxi",
description: "Pune to Gujarat taxi provides convenient travel for intercity journeys. Customers can book taxis for flexible trips. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Gujarat Taxi Service",
description: "Pune to Gujarat taxi service offers dependable transportation for long-distance travel. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Gujarat Cab Booking",
description: "Pune to Gujarat cab booking provides easy reservation options for travelers. Customers can book cabs online or via phone. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab easily."
},
{
name: "Pune to Gujarat Taxi Booking",
description: "Pune to Gujarat taxi booking offers quick booking options for customers. Travelers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily."
},
{
name: "Pune to Gujarat One Way Cab",
description: "Pune to Gujarat one way cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way cab services."
},
{
name: "Pune to Gujarat One Way Taxi",
description: "Pune to Gujarat one way taxi provides convenient travel for single-direction trips. Customers can book taxis for flexible journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one way taxi services."
},
{
name: "Pune to Gujarat Cab Fare",
description: "Pune to Gujarat cab fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel easily with cab fare services."
}
],

tableData: [
["Pune to Surat Cab Booking","Pune to Surat Cab Price"],
["Pune to Surat Cab","Pune to Surat Taxi Cab Hire"],
["Pune to Gujarat Cab Booking","Pune to Ahmedabad Cab"],
["Pune to Vadodara Cab","Pune to Rajkot Cab Service"],
["Pune to Gujarat Round Trip Cab Service","Pune to Pavagadh Taxi Service"],
["Pune to Gandhinagar Gujarat Taxi Service","Pune to Somnath Trip with Murali Cabs"],
["Pune to Bhavnagar Cab Service","Pune Vadodara Cab Booking"],
["Pune to Gujarat Tempo Traveller on Rent","Pune to Rajkot Cab"],
["Pune to Statue of Unity Cab","Pune to Gujarat Cab Service"],
["Pune to Gujarat Cab","Pune to Gujarat Taxi"],
["Pune to Gujarat Taxi Service","Pune to Gujarat Cab Booking"],
["Pune to Gujarat Taxi Booking","Pune to Gujarat One Way Cab"],
["Pune to Gujarat One Way Taxi","Pune to Gujarat Cab Fare"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Interstate Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers experienced in Pune to Gujarat routes, ensuring safe highway driving across Maharashtra and Gujarat with smooth intercity travel."
  },
  {
    WhyChooseheading: "Affordable Pune to Gujarat Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Gujarat cab services with transparent pricing. Customers receive full fare details including tolls, state taxes, and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "Coverage Across Major Gujarat Cities",
    WhyChoosedescription: "Our cab service covers Ahmedabad, Surat, Vadodara, Rajkot, Somnath, Dwarka, and other major destinations in Gujarat with flexible travel plans."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Gujarat cab bookings, making it convenient for business trips, family travel, and pilgrimage journeys."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "We provide clean, well-maintained, and air-conditioned vehicles designed for long-distance comfort, ensuring a relaxed journey."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We offer one-way cab service, round-trip bookings, and customized travel packages based on your itinerary and travel duration."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individual, family, and group travel."
  },
  {
    WhyChooseheading: "Trusted Interstate Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Gujarat cab bookings due to reliable service, experienced drivers, and comfortable long-distance travel experience."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Gujarat cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Gujarat for interstate travel." },
  { question: "Which cities in Gujarat do you cover?", answer: "We cover Ahmedabad, Surat, Vadodara, Rajkot, Dwarka, Somnath, and many more cities in Gujarat." },
  { question: "How far is Gujarat from Pune?", answer: "Distance varies by city. Surat is around 400 km, Ahmedabad around 650 km, and Somnath around 900 km from Pune." },
  { question: "Is Pune to Gujarat cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Gujarat travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab to Gujarat?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide multi-day travel plans?", answer: "Yes, we offer customized multi-day travel packages for Gujarat tours." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance journeys." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Gujarat cab service online or via phone." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Jignesh Patel",
    feedback:
      "Booked SRS Cab Service for Pune to Surat trip. Very smooth journey and professional driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Kavita Shah",
    feedback:
      "Excellent Pune to Gujarat cab service. Comfortable ride and perfect for long-distance travel.",
    rating: 5
  }
];




























const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Pune to Gujarat Cab Service",
  "description": "Book reliable cab service from Pune to Gujarat including Surat, Ahmedabad, Vadodara, Rajkot, Bhavnagar, Pavagadh, and Gandhinagar. One-way, round trip, and tempo traveller rentals available.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/pune-to-gujarat-cab-service",
  "priceRange": "₹₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1580"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune and Gujarat"
  }
};







  return (
    <div>
      

<Helmet>
  <title>Pune to Gujarat Cab Service | Surat, Ahmedabad, Vadodara & More | SRS Cab</title>
  <meta 
    name="description" 
    content="Hire trusted cab service from Pune to Gujarat with SRS Cab. Covering Surat, Ahmedabad, Vadodara, Rajkot, Bhavnagar, Pavagadh, and Gandhinagar. One-way, round trip & tempo traveller rentals available." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>


 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogujratcabservice;